import { create } from 'zustand';
import type { User } from '@cockpit/shared';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isBootstrapped: boolean; // true après l'appel initial à /api/auth/me
  setUser: (user: User | null) => void;
  setBootstrapped: () => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isBootstrapped: false,
  setUser: (user) => {
    set({ user, isAuthenticated: user !== null });
  },
  setBootstrapped: () => {
    set({ isBootstrapped: true });
  },
  clear: () => {
    set({ user: null, isAuthenticated: false });
  },
}));
